module.exports = __webpack_public_path__ + "static/media/ug.e80e0413.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ug.svg
// module id = 971
// module chunks = 0